import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_25: FaireProductEntity = {
  token: "catalog_prod_prod-25",
  type: "product",
  name: "Decorative Item A",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 95.59,
  msrpDollars: 238.98,
  sku: "PA0025",
  caseSize: 2,
  material: "Glass",
  collectionToken: "col_pattern-play",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 291,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["catalog_cat_candles-holders"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
